// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_hk","gallery__header":"c-o_hl","gallery__thumbs":"c-o_hm"};